import type { ReactNode } from "react";
import type { ColumnDef } from "@tanstack/react-table";

/**
 * Thin wrapper over TanStack's ColumnDef so configs read declaratively.
 * `value` powers both client-side sorting and the global text filter; `cell`
 * renders. Columns without a `value` are display-only (no sort/filter).
 */
export function col<T>(opts: {
  id: string;
  header: string;
  value?: (row: T) => string | number | null | undefined;
  cell: (row: T) => ReactNode;
  sortable?: boolean;
}): ColumnDef<T, unknown> {
  return {
    id: opts.id,
    header: opts.header,
    accessorFn: (row: T) => {
      const v = opts.value?.(row);
      return v ?? "";
    },
    enableSorting: opts.sortable ?? opts.value !== undefined,
    enableGlobalFilter: opts.value !== undefined,
    cell: (ctx) => opts.cell(ctx.row.original),
  };
}
